module.exports = __webpack_public_path__ + "static/Spring-Boot-b37b7011af7849d46995b658ee5516b2.png";